"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STANDALONE_SYSTEMID = void 0;
var STANDALONE_SYSTEMID = exports.STANDALONE_SYSTEMID = "Standalone-1";